import { SUBSCRIPTION_COMPONENT_TRANSLATIONS as T } from "@/components/subscription/constants";
import { Button } from "@/domains/shared/components/Button";
import type { PlanChangeSecretaryCandidates } from "@/domains/subscription/planChangeSecretaryCandidates";
import { getTranslation } from "@mivo/i18n";

type SecretaryMigrationStepProps = {
    summary: PlanChangeSecretaryCandidates | undefined;
    selectedSecretaryUserId: string | null;
    onSelectSecretary: (userId: string | null) => void;
    onBack: () => void;
    onContinue: () => void;
};

export default function SecretaryMigrationStep({ summary, selectedSecretaryUserId, onSelectSecretary, onBack, onContinue }: SecretaryMigrationStepProps) {
    const members = summary?.items ?? [];

    return (
        <div className="space-y-4 text-sm text-muted-foreground">
            <p>{getTranslation(T.secretaryMigrationIntro)}</p>
            <div className="flex flex-col gap-2">
                {members.map((member) => (
                    <Button
                        key={member.userId}
                        type="button"
                        variant={selectedSecretaryUserId === member.userId ? "default" : "outline"}
                        className="justify-start h-auto py-2"
                        onClick={() => onSelectSecretary(member.userId)}
                    >
                        <span className="flex flex-col items-start gap-0.5 text-left">
                            <span className="font-semibold text-secondary-foreground">{member.name}</span>
                            <span className="text-xs text-muted-foreground">{member.email}</span>
                        </span>
                    </Button>
                ))}
                <Button type="button" variant={selectedSecretaryUserId === null ? "default" : "outline"} onClick={() => onSelectSecretary(null)}>
                    {getTranslation(T.secretaryMigrationSkip)}
                </Button>
            </div>
            <div className="flex flex-row gap-2">
                <Button variant="outline" className="flex-1" onClick={onBack}>
                    {getTranslation(T.back)}
                </Button>
                <Button className="flex-1" onClick={onContinue}>
                    {getTranslation(T.continue)}
                </Button>
            </div>
        </div>
    );
}
